<template>
  <appMeetingResolutionsTable
    :meeting-id="meetingId"
    :building-id="buildingId"
    @hideParentActionButtons="$emit('hideParentActionButtons', $event)"
  />
</template>

<script>
import appMeetingResolutionsTable from "@/components/snippets/MeetingResolutionsTable";

export default {
  components: {
    appMeetingResolutionsTable,
  },
  props: {
    meetingId: {
      type: String,
      default: "",
    },
    buildingId: {
      type: String,
      default: "",
    },
  },
};
</script>
